<template>
  <div id="my-rewards-tab-v2">
    <b-row no-gutters="">
      <b-col>
        <RewardsNav></RewardsNav>
      </b-col>
    </b-row>
    <div class="rewards-body">
      <b-row>
        <b-col>
          <div class="rewards-content">
            <div class="mb-4">
              <b-row>
                <b-col sm="3">
                  <div class="filter-wrapper">
                    <b-form-select
                      v-model="selectedRewardTypeOption"
                      :options="rewardTypeOptions"
                      class="w-100"
                    />
                  </div>
                </b-col>
                <b-col sm="5" md="4" class="pl-md-0 pr-md-0">
                  <div class="filter-wrapper">
                    <b-input-group prepend=" ">
                      <b-form-input
                        @keyup.native="searchRewards(true)"
                        placeholder="Search"
                        v-model="searchString"
                      ></b-form-input>
                      <b-dropdown
                        text="Advanced"
                        variant="primary"
                        slot="append"
                      >
                        <b-dropdown-item
                          @click="searchOption(option.value)"
                          v-for="option in advancedSearchOptions"
                          :key="option.value"
                        >
                          {{ option.text }}
                          <i
                            v-if="selectedAdvancedSearchOption === option.value"
                            class="ml-1"
                          >
                            <img
                              width="15"
                              height="15"
                              src="@/assets/images/checked-symbol.svg"
                              alt=""
                              class="mr-1"
                            />
                          </i>
                        </b-dropdown-item>
                      </b-dropdown>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col sm="4" md="5">
                  <b-button
                    @click="showNewRewardModal"
                    variant="primary"
                    class="float-right new-button"
                    :class="
                      (planId == 1 || planId == 2) && rewards.length == 5
                        ? 'disableContent'
                        : ''
                    "
                    v-b-tooltip.hover
                    :title="
                      (planId == 1 || planId == 2) && rewards.length == 5
                        ? 'You have reached your reward limit'
                        : ''
                    "
                    :disabled="
                      (planId == 1 || planId == 2) && rewards.length == 5
                    "
                  >
                    + New Reward
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <div class="mt-3">
              <div class="data-container position-relative">
                <div id="multiple-select-action" v-if="selectedRewards.length">
                  <span id="selected-rewards-count">
                    {{ selectedRewards.length }} Selected
                  </span>
                  <span
                    class="icon icon-delete align-middle mx-2"
                    @click="showDeleteRewardsModal"
                  ></span>
                  <span class="icon icon-download align-middle mx-2"></span>
                </div>
                <b-table
                  :items="isSearchType ? [] : rewards"
                  :fields="fields"
                  :current-page="currentPage"
                  ref="rewardsList"
                  show-empty
                  :empty-text="emptyText"
                  @row-hovered="onTableRowHover"
                >
                  <template slot="HEAD_uuid" slot-scope="data">
                    <b-form-checkbox
                      v-if="data"
                      v-model="selectAllRewards"
                      @click.native.stop
                    >
                    </b-form-checkbox>
                  </template>
                  <template slot="uuid" slot-scope="data">
                    <b-form-checkbox
                      v-if="data"
                      v-model="selectedRewards"
                      :value="data.value"
                    >
                    </b-form-checkbox>
                  </template>
                  <template slot="image" slot-scope="data">
                    <div class="image-wrapper">
                      <img
                        v-if="data.value !== ''"
                        :src="data.value"
                        alt="Sample Brand Image"
                      />
                      <img
                        v-else
                        src="../../assets/images/sample-badge.png"
                        alt="Sample Brand Image"
                      />
                    </div>
                  </template>
                  <template slot="name" slot-scope="data">
                    <span
                      :class="{
                        'text-danger':
                          data.item.type === 'Points' &&
                          !data.item.is_unlimited_inventory &&
                          data.item.inventory === 0,
                      }"
                      >{{ data.value }}</span
                    >
                  </template>
                  <template slot="inventory" slot-scope="data">
                    <template>
                      <span v-if="data.item.is_unlimited_inventory">
                        Unlimited
                      </span>
                      <span
                        v-else
                        :class="{ 'text-danger': data.value <= 0 }"
                        >{{ data.value > 0 ? data.value : 0 }}</span
                      >
                    </template>
                  </template>
                  <template slot="points" slot-scope="data">
                    <span
                      :class="{
                        'text-danger':
                          data.item.type === 'Points' &&
                          !data.item.is_unlimited_inventory &&
                          data.item.inventory === 0,
                      }"
                      >{{ data.value }}</span
                    >
                  </template>
                  <template slot="price" slot-scope="data">
                    <div :id="`popover-${data.index}`">
                      Php {{ data.value | regularPrice }}
                    </div>
                    <b-popover
                      :target="`popover-${data.index}`"
                      triggers="hover focus"
                      placement="top"
                      :container="`popover-${data.index}`"
                    >
                      <b-row no-gutters>
                        <b-col class="text-center">
                          <span
                            class="icon icon-edit"
                            @click="editReward(data.item.uuid)"
                          ></span>
                        </b-col>
                        <b-col class="text-center">
                          <span
                            class="icon icon-share"
                            v-b-modal.share-reward-modal
                          ></span>
                        </b-col>
                        <b-col class="text-center">
                          <b-col class="text-center">
                            <span class="icon icon-download"></span>
                          </b-col>
                        </b-col>
                        <b-col class="text-center">
                          <switches
                            v-if="data.item.inventory > 0"
                            :value="data.item.is_enabled"
                            text-enabled="On"
                            text-disabled="Off"
                            theme="custom"
                            color="primary"
                            type-bold="true"
                            style="top: -17px"
                          >
                          </switches>
                          <switches
                            v-else
                            :value="false"
                            text-enabled="On"
                            text-disabled="Off"
                            theme="custom"
                            color="primary"
                            type-bold="true"
                            style="top: -17px"
                          >
                          </switches>
                        </b-col>
                        <b-col class="text-center">
                          <div
                            class="icon icon-kebab"
                            :id="`popover-menu-${data.index}`"
                          ></div>
                          <b-popover
                            :target="`popover-menu-${data.index}`"
                            triggers="click focus"
                            placement="left"
                            class="px-0"
                            :container="`popover-menu-${data.index}`"
                          >
                            <div class="popover-menu-item d-none">
                              Duplicate Record
                            </div>
                            <div
                              v-if="data.item.type === 'Instant Gratification'"
                              class="popover-menu-item"
                              @click="
                                $router.push({
                                  name: 'MyRewardsCodes',
                                  params: { rewardUuid: data.item.uuid },
                                })
                              "
                            >
                              View Codes
                            </div>
                            <div class="popover-menu-item d-none">Generate QR</div>
                            <div
                              id="popover-menu-delete-reward"
                              class="popover-menu-item"
                              @click="showDeleteRewardModal(data.item)"
                            >
                              Delete Reward
                            </div>
                          </b-popover>
                        </b-col>
                      </b-row>
                    </b-popover>
                  </template>
                  <template slot="is_admin_approved" slot-scope="data">
                    <template v-if="data.value == 0"> Pending </template>
                    <template v-else-if="data.value == 1"> Approved </template>
                    <template v-else> Rejected </template>
                  </template>
                </b-table>
              </div>
            </div>
            <div>
              <b-row v-if="rewards.length">
                <b-col>
                  <div class="mt-1">
                    <span class="pagination-indicator">
                       {{ firstItemPage }}-{{ lastItemPage("rewards") }} of
                      {{ maxPage }} pages
                    </span>
                    <b-pagination
                      hide-goto-end-buttons
                      hide-ellipsis
                      align="left"
                      size="md"
                      :limit="3"
                      :total-rows="maxPage * rewards.length"
                      :per-page="rewards.length"
                      @change="paginate"
                      :value="currentPage"
                      class="custom-pagination-arrow-only mb-0 ml-2"
                    >
                    </b-pagination>
                  </div>
                </b-col>
              </b-row>
            </div>
            <NewRewardModal ref="newRewardModal" />
            <ShareRewardModal />
            <DeleteRewardModal :selectedReward="selectedReward" />
            <DeleteRewardsModal @deleteRewards="deleteRewards" />
            <UploadRewardImageModal />
            <UpdateRewardModal ref="updateRewardModal" />
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import RewardsNav from "./RewardsNav.vue";
import Switches from "vue-switches";
import Datepicker from "vuejs-datepicker";
import { mapState, mapGetters, mapActions } from "vuex";
import _ from "lodash";
import NewRewardModal from "./NewRewardModal";
import ShareRewardModal from "./ShareRewardModal";
import DeleteRewardModal from "./DeleteRewardModal";
import DeleteRewardsModal from "./DeleteRewardsModal";
import UploadRewardImageModal from "./UploadRewardImageModal";
import UpdateRewardModal from "./UpdateRewardModal";

export default {
    name: "MyRewardsTabV2",
    data() {
        return {
            selectedReward: null,
            isRewardRejected: false,
            fields: [
                "uuid",
                { key: "image", label: "Reward Image", sortable: true },
                { key: "name", label: "Reward Name", sortable: true },
                { key: "inventory", sortable: true },
                { key: "points", label: "Points Value", sortable: true },
                { key: "price", label: "Reward Value", sortable: true },
                { key: "type", label: "Reward Type", sortable: true }
            ],
            searchString: "",
            selectedRewardTypeOption: "all",
            selectedAdvancedSearchOption: "all",
            selectedRewards: [],
            emptyText: "Loading...",
            isSearchType: false,
            rewardDescriptionMaxLength: 2000,
            redeemInstructionMaxLength: 2000,
            freeRewardMaxLength: 20,
            disabledDates: {
                to: new Date(new Date().setDate(new Date().getDate() - 1))
            },
            branch_search: "",
            category_search: "",
            is_search: true,
            is_category_search: true,
            selected_branch: [],
            added_branches: [],
            env: process.env.VUE_APP_MODE,
            rewardUuid: null,
            rewardName: "",
            selectedAudience: "default",
            rewardTypeOptions: [],
            advancedSearchOptions: [],
            selectedBrand: null,
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline"],
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ indent: "-1" }, { indent: "+1" }]
            ]
        };
    },
    created() {
        this.getRewardOptions().then(() => {
            const { types, options } = this.rewardOptions;

            for (const [key, value] of Object.entries(types)) {
                this.rewardTypeOptions.push({ value: key, text: value });
            }

            for (const [key, value] of Object.entries(options)) {
                this.advancedSearchOptions.push({ value: key, text: value });
            }
        });
        this.getRewards(1).then(() => {
            if (!this.rewards.length) this.emptyText = "No Records Found";
        });
        this.getSearchCategories();
        this.getBranches();
        this.getBrands();
        this.getTopUps();
    },
    computed: {
        selectAllRewards: {
            get() {
                return this.rewards
                    ? this.selectedRewards.length === this.rewards.length
                    : false;
            },
            set(value) {
                let selectedRewards = [];

                if (value) {
                    _.forEach(this.rewards, reward => {
                        selectedRewards.push(reward.uuid);
                    });
                }

                this.selectedRewards = selectedRewards;
            }
        },
        ...mapState("rewards", [
            "rewards",
            "rewardDetails",
            "maxPage",
            "currentPage",
            "searching",
            "editing",
            "form",
            "errors",
            "currencyOptions",
            "loading",
            "searchCategories",
            "rewardOptions"
        ]),
        ...mapGetters("rewards", [
            "firstItemPage",
            "lastItemPage",
            "rewardDetails"
        ]),
        ...mapState("auth", ["enabledTopUps", "planId", "unavailableToPlan"]),
        ...mapState("brands", ["brands"]),
        ...mapState("rewards", ["categories"])
    },
    watch: {
        selectedRewardTypeOption() {
            this.searchRewards(true);
        }
    },
    components: {
        RewardsNav,
        Switches,
        Datepicker,
        NewRewardModal,
        ShareRewardModal,
        DeleteRewardModal,
        DeleteRewardsModal,
        UploadRewardImageModal,
        UpdateRewardModal
    },
    filters: {
        regularPrice(value) {
            if (!value) return "0.00";

            return Number.parseFloat(value).toFixed(2);
        }
    },
    methods: {
        ...mapActions("rewards", [
            "getSearchCategories",
            "getRewards",
            "getBranches",
            "search",
            "initializeForm",
            "getRewardOptions"
        ]),
        ...mapActions({
            getTopUps: "auth/getTopUps",
            viewReward: "rewards/viewReward"
        }),
        onTableRowHover(_, index) {
            this.$root.$emit("bv::hide::popover");
            this.$root.$emit("bv::show::popover", `popover-${index}`);
        },
        async getBrands() {
            this.$store.dispatch("brands/getBrands").then(() => {
                this.brandOptions = _.map(this.brands, function(value) {
                    return { value: value.uuid, text: value.name };
                });
            });
        },
        showNewRewardModal() {
            this.$store.dispatch("rewards/editing", false);
            this.initializeForm();
            this.$root.$emit("bv::show::modal", "new-reward-modal");
        },
        showDeleteRewardsModal() {
            this.$root.$emit("bv::show::modal", "delete-rewards-modal");
        },
        deleteRewards() {
            this.$store.dispatch(
                "rewards/multipleDelete",
                this.selectedRewards
            );
            this.selectedRewards = [];
            this.$root.$emit("bv::hide::modal", "delete-rewards-modal");
        },
        openPicker() {
            this.$refs.programaticOpen.showCalendar();
        },
        paginate(page) {
            if (this.searching) {
                return this.searchRewards(false, page);
            }
            return this.getRewards(page);
        },
        searchRewards(newSearch = false, page) {
            const parameters = {
                apiFields: {
                    filters: {
                        keyword: this.searchString,
                        column: this.selectedAdvancedSearchOption
                    },
                    type: this.selectedRewardTypeOption
                },
                page: newSearch === true ? 1 : page
            };

            if (newSearch) {
                this.emptyText = "Searching...";
                this.isSearchType = true;
            }
            const _this = this;
            this.search(parameters).then(() => {
                if (_this.searchString.trim())
                    _this.emptyText =
                        'No Records Found for "' + _this.searchString + '"';
                else _this.emptyText = "No Results Found";

                _this.isSearchType = false;
            });
        },
        searchOption(value) {
            this.selectedAdvancedSearchOption = value;

            if (this.searchString.trim()) {
                this.searchRewards(true);
            }
        },
        unSelectAll() {
            this.selectedRewards = [];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            return this.errors.errors[field];
        },
        setVisibility(index) {
            this.rewards[index].is_enabled = !this.rewards[index].is_enabled;
            const reward = this.rewards[index];
            let param = {
                apiFields: {
                    is_enabled: reward.is_enabled
                },
                uuid: reward.uuid,
                index: index
            };
            this.$store.dispatch("rewards/visibility", param);
        },
        showDeleteRewardModal(selectedReward) {
            this.selectedReward = selectedReward;
            this.$nextTick(() => {
                this.$root.$emit("bv::show::modal", "delete-reward-modal");
            });
        },
        async editReward(uuid) {
            await this.viewReward(uuid);
            this.$store.dispatch("rewards/editing", true);
            this.initializeForm();
            this.$root.$emit("bv::show::modal", "edit-reward-modal");
        }
    }
};
</script>

<style lang="scss" scoped>
#my-rewards-tab-v2 .filter-wrapper .custom-select {
  background-position: right center;
  background-origin: content-box;
  padding: 0.375rem 0.75rem 0.375rem 0.75rem;
}
</style>
